"use client";

import React from "react";
import { Leaf, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisionYCompromiso() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="232070" id="unsere-mission-vertrauen" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">

        {}
        <div ref={sectionRef} className={`flex items-center gap-3 mb-16 transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Leaf className="size-4 text-primary" />
          <span className="text-xs uppercase tracking-widest font-mono font-medium" style={{
          color: "var(--muted-foreground)"
        }}>
            Unsere Mission
          </span>
          <div className="flex-1 h-px" style={{
          background: "var(--border)"
        }} />
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">

          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-1000 delay-200 ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            {}
            <div className="relative rounded-md overflow-hidden shadow-2xl" style={{
            boxShadow: "var(--shadow-4xl)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/securenetics_soc_operations.png" alt="SecureNetics Security Operations Center" className="w-full object-cover grayscale hover:grayscale-0 transition-all duration-700" style={{
              aspectRatio: "3/4",
              maxHeight: "600px"
            }} />
              {}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(to top, var(--background) 0%, transparent 60%)",
              opacity: 0.6
            }} />
            </div>

            {}
            <p className="mt-4 text-xs font-mono uppercase tracking-widest" style={{
            color: "var(--muted-foreground)"
          }}>
              SOC — Perimeter Protection
            </p>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-start pt-0 lg:pt-8 transition-all duration-1000 delay-300 ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <blockquote className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight mb-10" style={{
            color: "var(--foreground)",
            letterSpacing: "-0.02em",
            fontWeight: 300
          }}>
              <span className="block text-6xl md:text-7xl font-serif mb-2" style={{
              color: "var(--primary)",
              lineHeight: 1
            }}>
                &ldquo;
              </span>
              Sicherheit ist kein Produkt, sondern ein Prozess des Vertrauens.
              <span className="block text-6xl md:text-7xl font-serif mt-2 text-right" style={{
              color: "var(--primary)",
              lineHeight: 1
            }}>
                &rdquo;
              </span>
            </blockquote>

            {}
            <div className="w-16 h-0.5 mb-10" style={{
            background: "var(--primary)"
          }} />

            {}
            <div className="mb-8 pl-0 lg:pl-8">
              <h2 className="font-default text-xl font-bold mb-4 tracking-tight" style={{
              color: "var(--foreground)"
            }}>
                Unsere Vision
              </h2>
              <p className="font-default text-base leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                Bei SecureNetics streben wir nach einer digitalen Welt, in der technologische Exzellenz und kompromisslose Sicherheit Hand in Hand gehen. Wir entwickeln maßgeschneiderte Strategien, die nicht nur Ihre Infrastruktur schützen, sondern die Grundlage für nachhaltiges digitales Wachstum bilden.
              </p>
            </div>

            {}
            <div className="mb-10 pl-0 lg:pl-8">
              <h2 className="font-default text-xl font-bold mb-4 tracking-tight" style={{
              color: "var(--foreground)"
            }}>
                Unser Versprechen
              </h2>
              <p className="font-default text-base leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                Jede Lösung, die wir implementieren, basiert auf tiefgreifender Expertise und modernster Analytik. Wir stehen für strategische Beratung auf Augenhöhe, damit Ihre Systeme nicht nur funktionieren, sondern in einer feindlichen digitalen Umgebung absolut vertrauenswürdig bleiben.
              </p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 pl-0 lg:pl-8">
              {["Ganzheitliche Cybersecurity-Lösungen", "Strategische Infrastrukturberatung", "Echtzeit-Bedrohungsanalyse im SOC", "Enterprise-Grade Sicherheitsstandards"].map((value, i) => <div data-index={i} key={i} className="flex items-start gap-3">
                  <div className="mt-1 size-2 rounded-none shrink-0 rotate-45" style={{
                background: "var(--primary)"
              }} />
                  <span className="font-mono text-sm leading-relaxed" style={{
                color: "var(--muted-foreground)"
              }}>
                    {value}
                  </span>
                </div>)}
            </div>

            {}
            <div className="pl-0 lg:pl-8">
              <Button asChild size="lg" className="group rounded-none bg-primary text-primary-foreground hover:shadow-[0_0_15px_rgba(0,255,255,0.3)] transition-all">
                <Link to="/SecuritySolutionsPage">
                  Sicherheitsstrategie entdecken
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}